'use client';

import Script from 'next/script';
import { useEffect, useState } from 'react';

export default function MetaPixelScript() {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // Check if already initialized
    if (typeof window !== 'undefined' && window._fbq_pixel_427953549859506) {
      setIsInitialized(true);
    }
  }, []);

  // Don't render script if already initialized
  if (isInitialized) {
    return null;
  }

  return (
    <>
      <Script
        id="meta-pixel-base"
        strategy="afterInteractive"
        onLoad={() => {
          if (typeof window !== 'undefined' && !window._fbq_pixel_427953549859506) {
            // Initialize only if not already done
            if (window.fbq) {
              window.fbq('init', '427953549859506');
              window.fbq('track', 'PageView');
              window._fbq_pixel_427953549859506 = true;
              setIsInitialized(true);
            }
          }
        }}
      >
        {`
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
        `}
      </Script>
      
      {/* NoScript fallback */}
      <noscript>
        <img 
          height="1" 
          width="1" 
          style={{ display: 'none' }}
          src="https://www.facebook.com/tr?id=427953549859506&ev=PageView&noscript=1"
          alt=""
        />
      </noscript>
    </>
  );
} 